import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectStartupProgress, selectStartupError, doInitiateKeycloak } from 'app/store/startup';
import { selectIsUserFullyAuthenticated } from 'app/store/users';
import { StartUp } from './StartUp.jsx';

const mapStateToProps = createStructuredSelector({
    startupProgress: selectStartupProgress,
    startupError: selectStartupError,
    isUserFullyAuthenticated: selectIsUserFullyAuthenticated
});

const mapDispatchToProps = {
    onInitiateKeycloak: doInitiateKeycloak
};
export const StartUpContainer = connect(mapStateToProps, mapDispatchToProps)(StartUp);
